import dayjs from 'dayjs'
import { capitalize } from 'lodash'

import { locales } from './date'

/** From the nex 10 days returns an array of dates excluding weekend days */
export const getContactDates = (fromToday: boolean = false, dayToGenerate = 5): Date[] => {
  const dateList: Date[] = []

  const offset = fromToday ? 0 : 1

  for (let i = 0; i < dayToGenerate; i++) {
    const date = addBusinessDays(new Date(), i + offset)
    dateList.push(getStartDatetime(date))
  }

  const d = new Date()
  d.setHours(16, 0, 0, 0)

  return dateList.filter((date) => {
    if (isToday(date)) {
      return date.getHours() < 18
    }
    return date > d
  })
}

export const getVisitDates = (fromToday: boolean = false): Date[] => {
  const dateList: Date[] = []

  const offset = fromToday ? 0 : 1

  for (let i = 0; i < 5; i++) {
    const date = addBusinessDays(new Date(), i + offset)
    dateList.push(getStartDatetime(date))
  }

  const d = new Date()
  d.setHours(16, 0, 0, 0)

  return dateList.filter((date) => {
    if (isToday(date)) {
      return date.getHours() < 18
    }
    return date > d
  })
}

export const getStartDatetime = (d: Date) => {
  if (isToday(d)) {
    const d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours() + 2, 0, 0)
    if (d1.getHours() >= 9) return d1
    d1.setHours(9, 0, 0)
    return d1
  }
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0)
}

export function mapDatesToLabelValue(dates: Date[], lang: Locale) {
  const language = locales[lang] || 'en-GB'
  return dates
    .map((date) => ({
      date,
      label: new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', weekday: 'short' }).format(date),
      value: date.toISOString().substring(0, 10),
    }))
    .sort((date1, date2) => date1.date.getTime() - date2.date.getTime())
}

export function getAvailableSchedulingDates(date: Date = new Date()) {
  date.setHours(9, 0, 0, 0)
  date = dayjs(date).add(1, 'day').toDate() // params only for testing
  let dateList: Date[] = []
  for (let i = 0; dateList.length < 10; i++) {
    const nextDay = addDays(date, i)
    if (!isSunday(nextDay)) {
      dateList.push(nextDay)
    }
  }
  return dateList
}

export const formatTime = (date: Date) => `${date.getHours()}:${date.toISOString().substring(14, 16)}`

export const isSunday = (date: Date) => {
  return date.getDay() === 0
}

export const isToday = (date: Date) => {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return d.getTime() === today.getTime()
}

export const addBusinessDays = (date: Date, n: number) => {
  let d = new Date(date)
  for (let i = 0; i < n; i++) {
    switch (d.getDay()) {
      case 5:
        d = addDays(d, 3)
        break
      case 6:
        d = addDays(d, 2)
        break
      default:
        d = addDays(d, 1)
        break
    }
  }
  return d
}

// TO BE REMOVED
export const getLocalizedDate = (date: Date, timeSlot: string, lang: Locale) => {
  const dateNumber = date.getDate()
  const language = locales[lang] || 'en-GB'
  const month = new Intl.DateTimeFormat(language, { month: 'long' }).format(date)

  const time = timeSlot !== '' ? timeSlot.split('-')[0] : '--:--'

  return {
    date_number: `${dateNumber}`,
    month,
    time,
  }
}

export const getReminderLocalizedDate = (date: Date, lang: Locale) => {
  const language = locales[lang] || 'en-GB'

  const dateNumber = date.getDate()
  const dayOfTheWeek = new Intl.DateTimeFormat(language, { weekday: 'long' }).format(date)
  const month = new Intl.DateTimeFormat(language, { month: 'long' }).format(date)
  const time = new Intl.DateTimeFormat(language, { hour: 'numeric', minute: 'numeric' }).format(date)

  return {
    date_number: `${dateNumber}`,
    day_of_the_week: capitalize(dayOfTheWeek),
    month: capitalize(month),
    time,
  }
}

export const addDays = (date: Date, amountDays: number) => {
  return dayjs(date).add(amountDays, 'day').toDate()
}
